var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnhanceComfortIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z",
    fill: "#EEF2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8361_1169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1807 12.3449C19.2164 12.1537 19.3179 11.9811 19.4675 11.8568C19.6171 11.7326 19.8054 11.6646 19.9999 11.6646C20.1943 11.6646 20.3827 11.7326 20.5323 11.8568C20.6819 11.9811 20.7833 12.1537 20.819 12.3449L21.6949 16.9765C21.7571 17.3058 21.9171 17.6087 22.1541 17.8457C22.391 18.0826 22.6939 18.2427 23.0232 18.3049L27.6549 19.1807C27.846 19.2164 28.0187 19.3179 28.1429 19.4675C28.2672 19.6171 28.3352 19.8054 28.3352 19.9999C28.3352 20.1943 28.2672 20.3827 28.1429 20.5323C28.0187 20.6819 27.846 20.7833 27.6549 20.819L23.0232 21.6949C22.6939 21.7571 22.391 21.9171 22.1541 22.1541C21.9171 22.391 21.7571 22.6939 21.6949 23.0232L20.819 27.6549C20.7833 27.846 20.6819 28.0187 20.5323 28.1429C20.3827 28.2672 20.1943 28.3352 19.9999 28.3352C19.8054 28.3352 19.6171 28.2672 19.4675 28.1429C19.3179 28.0187 19.2164 27.846 19.1807 27.6549L18.3049 23.0232C18.2427 22.6939 18.0826 22.391 17.8457 22.1541C17.6087 21.9171 17.3058 21.7571 16.9765 21.6949L12.3449 20.819C12.1537 20.7833 11.9811 20.6819 11.8568 20.5323C11.7326 20.3827 11.6646 20.1943 11.6646 19.9999C11.6646 19.8054 11.7326 19.6171 11.8568 19.4675C11.9811 19.3179 12.1537 19.2164 12.3449 19.1807L16.9765 18.3049C17.3058 18.2427 17.6087 18.0826 17.8457 17.8457C18.0826 17.6087 18.2427 17.3058 18.3049 16.9765L19.1807 12.3449Z",
    stroke: "#4F39F6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 11.6667V15.0001",
    stroke: "#4F39F6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 13.3333H25",
    stroke: "#4F39F6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 28.3333C14.2536 28.3333 14.9998 27.5871 14.9998 26.6667C14.9998 25.7462 14.2536 25 13.3332 25C12.4127 25 11.6665 25.7462 11.6665 26.6667C11.6665 27.5871 12.4127 28.3333 13.3332 28.3333Z",
    stroke: "#4F39F6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8361_1169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceComfortIcon);
export default __webpack_public_path__ + "static/media/enhance_comfort_icon.081d36a46528e2517b0a5b937f14285e.svg";
export { ForwardRef as ReactComponent };